/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  PutUsersIdPathParams,
  PutUsersId200,
  PutUsersId400,
  PutUsersId403,
  PutUsersIdMutationRequest,
  PutUsersIdMutationResponse,
} from '../entities/PutUsersId'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { updateUserRequestSchema } from './updateUserRequestSchema'
import { z } from 'zod'

export const putUsersIdPathParamsSchema = z.object({
  id: z.string().describe('ID пользователя'),
}) as unknown as ToZod<PutUsersIdPathParams>

/**
 * @description OK
 */
export const putUsersId200Schema = z.any() as unknown as ToZod<PutUsersId200>

/**
 * @description Bad Request
 */
export const putUsersId400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<PutUsersId400>

/**
 * @description Forbidden
 */
export const putUsersId403Schema = z.any() as unknown as ToZod<PutUsersId403>

/**
 * @description Обновление пользователя
 */
export const putUsersIdMutationRequestSchema = z.lazy(() => updateUserRequestSchema) as unknown as ToZod<PutUsersIdMutationRequest>

export const putUsersIdMutationResponseSchema = z.lazy(() => putUsersId200Schema) as unknown as ToZod<PutUsersIdMutationResponse>